//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import '@/mixins/global'
import axios from 'axios'
import Page06Sub from '../components/Page06Sub'

export default {
  components: {
    Page06Sub
  },
  data () {
    return {
      pagename: 'page06',
      period: [],
      periodType: 'EDD_W_NEW',
      Refresh: true,
      Ready: 'ALL',
      date: '',
      location: 'G1',
      locations: ['G1', 'G2', 'G3', 'G4', 'G5', 'TRM', 'VN', 'INDO'],
      andons: ['Mechanic', 'Maintenance', 'Technique', 'QA', 'Management']
      // andons: ['Mechanic', 'Maintenance']
    }
  },
  created () {
    // ถ้าหาในนี้ไม่เจออาจจะอยู่ใน mixins -> global.js
    this.CheckLocal()
    this.LoadFirst()
  },
  async mounted () {
    this.getloc()
  },
  watch: {
    //  date: function(newValue, oldValue) { //test
    //  this.LoadData()
    // },
    location: function (newValue, oldValue) {
      this.Refresh = false
      setTimeout(() => {
        this.Refresh = true
      }, 100)
    },
    date: function (newValue, oldValue) {
      this.Refresh = false
      setTimeout(() => {
        this.Refresh = true
      }, 100)
    }
  },
  methods: {
    LoadFirst () {
      this.pulling = setTimeout(() => {
        this.chkAuthen('', '')
        this.CurrDate()
      }, 1000)
    },

    CurrDate () {
      try {
        let params = new FormData()
        axios({
          method: 'post',
          url: this.$api + 'Page06.php/curdate',
          data: params
        }).then((res) => {
          this.date = res.data.dte
        })
      } catch (err) {
        this.$q.notify({
          position: 'top-right',
          timeout: 2500,
          textColor: 'white',
          color: 'red',
          message: err,
          html: true
        })
      }
    },

    keeplocation () {
      this.keeploc(this.pagename, this.location)
    },

    getloc () {
      try {
        this.Refresh = false
        const postjson = {
          authen: { keycode: this.$keycode },
          input: {
            uid: this.$store.getters.uid,
            syscode: this.$syscode,
            pagename: this.pagename
          }
        }
        axios({
          method: 'post',
          url: `${this.$apiflask}/log/getloc`, // php
          data: postjson
        }).then((res) => {
          if (res.data.loc != null) {
            this.location = res.data.loc
          }
          this.Refresh = true
        })
      } catch (err) {
        this.$q.notify({
          position: 'top-right',
          timeout: 2500,
          textColor: 'white',
          color: 'red',
          message: err,
          html: true
        })
      }
    }
  }
}
